var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b({}, "div", _vm.$attrs, false),
    [
      _c("v-autocomplete", {
        staticClass: "custom-placeholder",
        attrs: {
          items: _setup.localCollection,
          loading: _setup.isLoading || _setup.props.loading,
          "search-input": _setup.textSearch,
          "return-object": _vm.returnObject,
          "hide-selected": _vm.hideSelected,
          "hide-no-data": _setup.hideData,
          "item-text": _vm.itemText,
          "item-value": _vm.itemValue,
          label: _vm.label,
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          placeholder: _vm.placeholder,
          outlined: _vm.outlined,
          dense: _vm.dense,
          "error-messages": _vm.errorMessages,
          "hide-details": _vm.hideDetails,
          "small-chips": _vm.smallChips,
        },
        on: {
          blur: _setup.onBlur,
          "update:menu": _setup.onUpdateMenu,
          "update:searchInput": function ($event) {
            _setup.textSearch = $event
          },
          "update:search-input": function ($event) {
            _setup.textSearch = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.multiple && _setup.showCheckbox
              ? {
                  key: "item",
                  fn: function ({ item, attrs, on }) {
                    return [
                      _c(
                        "v-list-item",
                        _vm._g(_vm._b({}, "v-list-item", attrs, false), on),
                        [
                          _c(
                            "v-list-item-action",
                            [
                              _c("v-simple-checkbox", {
                                attrs: { value: !!attrs.inputValue },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    on && on.click && on.click($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_setup.getItemText(item))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "no-data",
              fn: function () {
                return [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "py-0 px-2 text-caption" },
                        [
                          _c("span", [
                            _vm._v("Buscando por "),
                            _c("strong", { staticClass: "indigo--text" }, [
                              _vm._v(_vm._s(_setup.textSearch)),
                            ]),
                            _vm._v(", não foi encontrado."),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "append-outer",
              fn: function () {
                return [_vm._t("append-outer")]
              },
              proxy: true,
            },
            {
              key: "prepend-item",
              fn: function () {
                return [
                  _vm.showSelectAll && _vm.multiple
                    ? _c(
                        "v-list-item",
                        {
                          on: {
                            mousedown: function ($event) {
                              $event.preventDefault()
                            },
                            click: _setup.toggleSelectAll,
                          },
                        },
                        [
                          _c(
                            "v-list-item-action",
                            [
                              _c("v-icon", [
                                _vm._v(_vm._s(_setup.iconSelectAll())),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(" Selecionar todos "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showSelectAll && _vm.multiple
                    ? _c("v-divider", { staticClass: "mt-2" })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "append",
              fn: function () {
                return [
                  _vm.showAdd
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: { small: "", icon: "" },
                                            on: {
                                              click: _setup.openDialogCreate,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              btn: "",
                                              color: "green darken-1",
                                            },
                                          },
                                          [_vm._v("mdi-plus")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2409995748
                          ),
                        },
                        [_c("span", [_vm._v("Novo")])]
                      )
                    : _vm._e(),
                  _vm._t("append"),
                ]
              },
              proxy: true,
            },
            {
              key: "selection",
              fn: function ({ item, index }) {
                return [
                  index === 0
                    ? _c("span", [_vm._v(_vm._s(_setup.getItemText(item)))])
                    : _vm._e(),
                  index === 1
                    ? _c("span", { staticClass: "grey--text caption ml-1" }, [
                        _vm._v(
                          "(+" + _vm._s(_setup.model.length - 1) + " outros)"
                        ),
                      ])
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }